// import Axios from 'axios';
// const baseURL = process.env.REACT_APP_API_URL;
// const axiosInstance = Axios.create({
//   baseURL: baseURL,
// });
// axiosInstance.interceptors.request.use(
//   function (config) {
//     const token = localStorage.getItem('accessToken');
//     if (token) {
//       config.headers['Authorization'] = 'Bearer ' + token;
//       config.headers['ser'] = localStorage.getItem('ser');
//       config.headers['org'] = localStorage.getItem('org');
//     }
//     return config;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );
// // Add a response interceptor
// axiosInstance.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (error) {
//     if (
//     //   window.location.pathname !== '/' &&
//     //   window.location.pathname !== '/oddspage' &&
//       error.response.status === 401
//     ) {
//       window.location.href = '/auth-login';
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;

// const publicAxiosInstance = Axios.create({
//   baseURL: baseURL,
// });
// export { 
//   publicAxiosInstance 
// }


import Axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL;
const axiosInstance = Axios.create({
  baseURL: baseURL,
});

// No headers added, simplified request interceptor
axiosInstance.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      window.location.href = '/auth-login'; // Redirect on authentication error if needed
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

const publicAxiosInstance = Axios.create({
  baseURL: baseURL,
});

export { 
  publicAxiosInstance 
}
